import { IObjectsControllable } from "./IObjectsControllable";
import { ILinkedObjectGroupSpecifiable } from "./ILinkedObjectGroupSpecifiable";

export interface IGroupAlertAllowBehaviorSpecifiable {
  groupAlertAllowBehavior: IObjectsControllable<ILinkedObjectGroupSpecifiable>;
}

export function instanceOfIGroupAlertAllowBehaviorSpecifiable(instance: any): instance is IGroupAlertAllowBehaviorSpecifiable {
  return instance
      && (instance.groupAlertAllowBehavior !== undefined);
}
